import { render } from "./AppBreadcrumb.vue?vue&type=template&id=68681c19&scoped=true"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"

import "./AppBreadcrumb.vue?vue&type=style&index=0&id=68681c19&scoped=true&lang=scss"
import "./AppBreadcrumb.vue?vue&type=style&index=1&id=68681c19&lang=css"

import exportComponent from "D:\\eclipse\\workSpaceIDEA\\BioTechLeague_HUIDU_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68681c19"]])

export default __exports__